import React from 'react';
import SearchBar from './SearchBar';
import Collapsible from 'react-collapsible';
import Highlighter from 'react-highlight-words';
import { IoChevronDownOutline } from 'react-icons/io5';
import { MdAddCircle, MdRemoveCircle } from 'react-icons/md';
import { useRecoilValue } from 'recoil';

import { searchState } from '../state/searchState';
import { selectedTagsState } from '../state/selectedTagsState';
import { sideMenuState } from '../state/sideMenuState';
import { tariffarioState } from '../state/tariffarioState';
import { useResponsiveUtil } from '../util/responsive-util';
import { TabellaTariffario } from './TabellaTariffario';
import { Tabella } from './ui/Tabella';
import { TextEllipsis } from './ui/TextEllipsis';

export const Tariffario = () => {
    const tariffe = useRecoilValue(tariffarioState);
    const selectedIndex = useRecoilValue(sideMenuState);
    const search_string = useRecoilValue(searchState);
    const search_tags = useRecoilValue(selectedTagsState);
    const { isTabletDevice } = useResponsiveUtil();

    // Useful to open sections when an hash is supplied...
    const groupId = window.location.hash.substring(8); // Strip "#gruppo-"

    return (
        <div id="tariffario">
            <Tabella>
                {tariffe.map((sezione, index) => {
                    const isOpen = search_string !== "" || search_tags.length || selectedIndex == index || (`${sezione['Gruppo']}-${sezione['Sottogruppo']}` === groupId);

                    return (
                        <Collapsible
                            triggerStyle={{
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginTop: '135px',
                                color: selectedIndex !== index && selectedIndex ? '#fff' : 'inherit',
                                display: selectedIndex !== index && selectedIndex ? 'none' : 'flex'
                            }}
                            key={`branca_${index}`}
                            open={!isTabletDevice}
                            triggerDisabled={!isTabletDevice}
                            trigger={[
                                <TextEllipsis>
                                    <Highlighter
                                        highlightClassName="YourHighlightClass"
                                        searchWords={[search_string]}
                                        autoEscape={true}
                                        textToHighlight={sezione['Descrizione']} />
                                </TextEllipsis>,
                                isTabletDevice && <IoChevronDownOutline style={{ minWidth: '16px', minHeight: '16px' }} key={`branca_${index}_icon`} />
                            ]}
                            triggerWhenOpen={[
                                <h3 id={`gruppo-${sezione['Gruppo']}-${sezione['Sottogruppo']}`}>
                                    <Highlighter
                                        highlightClassName="YourHighlightClass"
                                        searchWords={[search_string]}
                                        autoEscape={true}
                                        textToHighlight={sezione['Descrizione']} />
                                </h3>,
                                isTabletDevice && <IoChevronDownOutline style={{ minWidth: '16px', minHeight: '16px' }} key={`branca_${index}_icon`} />
                            ]}
                        >
                            <div key={`sezione_${index}`} id={`sezione_${index}`} style={{ marginTop: '0', color: selectedIndex !== index && selectedIndex ? '#fff' : 'inherit', display: selectedIndex !== index && selectedIndex ? 'none' : 'inherit' }}>

                                {sezione.ElencoTariffe.length > 0 ?

                                    <TabellaTariffario tariffe={sezione.ElencoTariffe} /> :

                                    sezione.ElencoBranche.map((branca, index) => (
                                        branca?.ElencoSottobranche?.length > 0 ?
                                            <Collapsible
                                                key={`branca_${index}`}
                                                open={isOpen}
                                                trigger={[
                                                    <h4 style={{ color: '#276ef5' }} key={`branca_${index}_h4`}>
                                                        <Highlighter
                                                            highlightClassName="YourHighlightClass"
                                                            searchWords={[search_string]}
                                                            autoEscape={true}
                                                            textToHighlight={branca['Descrizione']} />
                                                    </h4>,
                                                    <MdAddCircle style={{ color: '#276ef5', minWidth: '16px', minHeight: '16px' }} key={`branca_${index}_icon`} />
                                                ]}
                                                triggerWhenOpen={[
                                                    <h4 style={{ color: '#276ef5' }} key={`branca_${index}_h4`}>
                                                        <Highlighter
                                                            highlightClassName="YourHighlightClass"
                                                            searchWords={[search_string]}
                                                            autoEscape={true}
                                                            textToHighlight={branca['Descrizione']} />
                                                    </h4>,
                                                    <MdRemoveCircle style={{ color: '#276ef5', minWidth: '16px', minHeight: '16px' }} key={`branca_${index}_icon`} />
                                                ]}
                                            >
												{branca.ElencoTariffe?.length > 0 ? <TabellaTariffario tariffe={branca.ElencoTariffe} /> : ''}

                                                {branca?.ElencoSottobranche.map((sottobranca, $j) => (
                                                    <>
                                                        <h3>
                                                            <Highlighter
                                                                highlightClassName="YourHighlightClass"
                                                                searchWords={[search_string]}
                                                                autoEscape={true}
                                                                textToHighlight={sottobranca['Descrizione']} />
                                                        </h3>
                                                        <TabellaTariffario tariffe={sottobranca.ElencoTariffe} />
                                                    </>
                                                ))}
                                            </Collapsible>
                                            :
                                            <Collapsible
                                                key={`branca_${index}`}
                                                open={isOpen}
                                                trigger={[
                                                    <h4 style={{ color: '#276ef5' }} key={`branca_${index}_h4`}>
                                                        <Highlighter
                                                            highlightClassName="YourHighlightClass"
                                                            searchWords={[search_string]}
                                                            autoEscape={true}
                                                            textToHighlight={branca['Descrizione']} />
                                                    </h4>,
                                                    <MdAddCircle style={{ color: '#276ef5', minWidth: '16px', minHeight: '16px' }} key={`branca_${index}_icon`} />
                                                ]}
                                                triggerWhenOpen={[
                                                    <h4 style={{ color: '#276ef5' }} key={`branca_${index}_h4`}>
                                                        <Highlighter
                                                            highlightClassName="YourHighlightClass"
                                                            searchWords={[search_string]}
                                                            autoEscape={true}
                                                            textToHighlight={branca['Descrizione']} />
                                                    </h4>,
                                                    <MdRemoveCircle style={{ color: '#276ef5', minWidth: '16px', minHeight: '16px' }} key={`branca_${index}_icon`} />
                                                ]}
                                            >
                                                <TabellaTariffario tariffe={branca.ElencoTariffe} />
                                            </Collapsible>
                                    ))
                                }
                            </div>
                        </Collapsible>)
                })}
            </Tabella>
        </div>
    )
}
